import { Permission } from '@/api';
import { PriceLookupPage } from '@/pages/admin/price-lookup/price-lookup-page';
import { ResetNoveltyPricesPage } from '@/pages/admin/reset-novelty-prices/reset-novelty-prices-page';
import { DevDashboardPage } from '@/pages/dev/dashboard/dev-dashboard-page';
import { SimulationListPage } from '@/pages/price-planning/simulation/simulation-list-page/simulation-list-page';
import { SimulationNotFoundPage } from '@/pages/price-planning/simulation/simulation-not-found-page';
import { PriceSetupCalcSettingsPage } from '@/pages/price-setup/calculation-settings/calculation-settings-page';
import { PriceCalculatorPage } from '@/pages/price-setup/price-calculator/price-calculator-page';
import { HomePage } from '@pages/home-page/home-page';
import { LoginPage } from '@pages/login-page';
import { UnauthorizedPage } from '@pages/unauthorized-page';
import type { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthGuard } from './components/auth/auth-guard';
import { RoleGuard } from './components/auth/role-guard';
import CopyPricePage from './pages/price-planning/copy-price-page/copy-price-page';
import CreatePricePage from './pages/price-planning/create-price-page/create-price-page';
import { SimulationReadOnlyProvider } from './pages/price-planning/simulation/simulation-tool-page/context/simulation-read-only-context';
import SimulationToolPage from './pages/price-planning/simulation/simulation-tool-page/simulation-tool-page';
import { ROUTES } from './routes';

export const RouteComponents = (): ReactElement => {
  return (
    <Routes>
      <Route path={ROUTES.Login.path} element={<LoginPage />} />
      <Route element={<AuthGuard />}>
        <Route path={ROUTES.Unauthorized.path} element={<UnauthorizedPage />} />

        <Route element={<RoleGuard />}>
          <Route path={ROUTES.Home.path} element={<HomePage />} />
          <Route
            path={ROUTES.SimulationList.path}
            element={<SimulationListPage />}
          />
          <Route element={<RoleGuard permission={Permission.CreatePrice} />}>
            <Route
              path={ROUTES.CreatePrice.path}
              element={<CreatePricePage />}
            />
          </Route>
          <Route path={ROUTES.CopyPrice.path} element={<CopyPricePage />} />
          <Route path={ROUTES.PriceLookup.path} element={<PriceLookupPage />} />
          <Route
            element={<RoleGuard permission={Permission.NoveltyCalculation} />}
          >
            <Route
              path={ROUTES.PriceCalculator.path}
              element={<PriceCalculatorPage />}
            />
          </Route>
          <Route
            element={
              <RoleGuard permission={Permission.ReadCalculationSettings} />
            }
          >
            <Route
              path={ROUTES.CalcSettings.path}
              element={<PriceSetupCalcSettingsPage />}
            />
          </Route>
          <Route
            element={<RoleGuard permission={Permission.DeleteNoveltyPrices} />}
          >
            <Route
              path={ROUTES.ResetNoveltyPrices.path}
              element={<ResetNoveltyPricesPage />}
            />
          </Route>
        </Route>
        <Route element={<RoleGuard permission={Permission.ReadSimulations} />}>
          <Route
            path={ROUTES.SimulationList.path}
            element={<SimulationListPage />}
          />
          <Route
            path={ROUTES.SimulationTool.path}
            element={
              <SimulationReadOnlyProvider>
                <SimulationToolPage />
              </SimulationReadOnlyProvider>
            }
          />
          <Route
            path={ROUTES.SimulationNotFound.path}
            element={<SimulationNotFoundPage />}
          />
        </Route>
        <Route
          element={<RoleGuard permission={Permission.AccessTestEndpoints} />}
        >
          <Route
            path={ROUTES.DevDashboard.path}
            element={<DevDashboardPage />}
          />
        </Route>
      </Route>
    </Routes>
  );
};
